// extracted by mini-css-extract-plugin
export default {"imageWrapper":"style-module--image-wrapper--53eaa"};